import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'


export const sendLink = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data, apiConstants.VIDEO.SEND_LINK)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default sendLink